/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
import mbpUtil from 'mbp-api-util';

// Plugin Config
const cardIslePluginConfig = {
    sdkURL: mbpUtil.getEnv('APP_CARD_ISLE_SDK_URL') || 'https://s3.amazonaws.com/cardisle.web/static/ecommerce/shop_embed.js',
    cardIsleOccasionURL: mbpUtil.getEnv('APP_CARD_ISLE_OCCASION_SDK_URL') || 'https://s3.us-east-1.amazonaws.com/cardisle.web/static/ecommerce/1800/1800PWA_v2.min.js',
};

export {
    cardIslePluginConfig,
};

export default {};
